import {
  CalendarGesture,
  GestureItem,
} from "@tento-ui/components/calendar/calendar-gesture";
import { ColumnIndex } from "@tento-ui/components/sheet/column-index";
import type { Option, RowLocalId } from "@tento-lona/sheets";
import { DateFragment } from "@tento-chrono";
import type { SubcolumnCreateHandler } from "@tento-lona/sheets-ui/sheet/calendar-subcolumn.ts";

export { GestureItem };

/**
 * Where a gesture happens: the row, the item under the pointer and the
 * resolved column.
 */
export class GestureInfo implements CalendarGesture.WindowedInfo {
  constructor(
    readonly rowId: RowLocalId,
    readonly item: Option<GestureItem>,
    readonly column: ColumnIndex.Key.Resolved.WithSubindex,
    readonly windowed: DateFragment.Windowed,
    readonly createHandler: Option<SubcolumnCreateHandler>,
    /**
     * Creatable subcolumn handlers for the column, deduped by their
     * plugin-declared opaque `createKey` (first per key, subcolumn
     * order). The layout layer fills this without interpreting keys;
     * app-layer gestures pick the entry matching their flow.
     */
    readonly createEntries: readonly GestureInfo.CreateEntry[] = [],
  ) {}

  toString(): string {
    return [this.rowId, this.windowed.toString()]
      .filter((s) => s != null)
      .join(" ");
  }
}

/** Types that go with `GestureInfo`: `CreateEntry`. */
export namespace GestureInfo {
  export type CreateEntry = {
    readonly key: Option<string>;
    readonly handler: SubcolumnCreateHandler;
  };
}
